import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import {
  createBrand,
  deleteBrandById,
  updateBrandById,
} from '../thunks/brands';

const brandsAdapter = createEntityAdapter({});

export const brandsSlice = createSlice({
  name: 'brands',
  initialState: brandsAdapter.getInitialState({}),
  reducers: {
    setBrands: (state, action) => {
      brandsAdapter.upsertMany(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createBrand.fulfilled, (state, action) => {
        brandsAdapter.addOne(state, action.payload);
      })
      .addCase(updateBrandById.fulfilled, (state, action) => {
        const { id } = action.payload;

        brandsAdapter.updateOne(state, {
          id,
          changes: action.payload,
        });
      })
      .addCase(deleteBrandById.fulfilled, (state, action) => {
        brandsAdapter.removeOne(state, action.payload.id);
      });
  },
});

export const { setBrands } = brandsSlice.actions;

export const brandsAdapterSelectors = brandsAdapter.getSelectors(
  (state) => state.brands
);

export default brandsSlice.reducer;
